module.exports = __webpack_public_path__ + "static/media/diamond-icon.b90f40b9.svg";